"use client";

import dynamic from "next/dynamic";

export const CustomPricingCardsDynamic = dynamic(() =>
  import("@ui/components/pricing/CustomPricingCards").then(mod => ({ default: mod.CustomPricingCards })),
);

export const PricingCardsV3ClientDynamic = dynamic(() =>
  import("@/app/_views/PricingCardsV3Client").then(mod => ({ default: mod.PricingCardsV3Client })),
);
